var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "list-group" },
      [
        _vm._l(_vm.menus, function(menu) {
          return ("hidden" in menu ? !menu.hidden : true)
            ? [
                menu.type === "heading"
                  ? _c(
                      "span",
                      {
                        key: menu.label,
                        staticClass:
                          "heading list-group-item pt-4 pl-0 border-left-0 border-top-0 h5 text-uppercase"
                      },
                      [_vm._v("\n        " + _vm._s(menu.label) + "\n      ")]
                    )
                  : menu.normal && menu.url
                    ? _c(
                        "a",
                        {
                          key: menu.label,
                          class: _vm.itemClass,
                          attrs: { href: menu.url }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-fw",
                            class: menu.icon
                          }),
                          _vm._v(" \n        " + _vm._s(menu.label) + " "),
                          _c("i", { staticClass: "fa fa-external-link" })
                        ]
                      )
                    : menu.click && menu.click
                      ? _c(
                          "a",
                          {
                            key: menu.label,
                            class: _vm.itemClass,
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                menu.click($event)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-fw",
                              class: menu.icon
                            }),
                            _vm._v(
                              " \n        " + _vm._s(menu.label) + "\n      "
                            )
                          ]
                        )
                      : _c(
                          "nuxt-link",
                          {
                            key: menu.label,
                            staticClass:
                              "d-inline-flex justify-content-between flex-nowrap text-overflow",
                            class: [
                              {
                                active:
                                  menu.active &&
                                  typeof menu.active === "function"
                                    ? menu.active()
                                    : menu.active || _vm.active(menu.url)
                              },
                              _vm.itemClass
                            ],
                            attrs: {
                              to: menu.url,
                              "data-toggle": "collapse",
                              "data-target": "#navbarSupportedContent.show",
                              exact: ""
                            }
                          },
                          [
                            _c("span", [
                              _c("i", {
                                staticClass: "fa fa-fw",
                                class: menu.icon
                              }),
                              _vm._v(
                                " \n          " +
                                  _vm._s(menu.label) +
                                  "\n          "
                              )
                            ]),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.active(menu.url),
                                    expression: "active(menu.url)"
                                  }
                                ]
                              },
                              [_c("i", { staticClass: "fa fa-chevron-right" })]
                            )
                          ]
                        )
              ]
            : _vm._e()
        })
      ],
      2
    ),
    _c("div", { staticClass: "py-3" }, [
      _c(
        "a",
        {
          staticClass: "text-muted",
          attrs: {
            href:
              _vm.npm_package_homepage +
              "/releases/tag/v" +
              _vm.npm_package_version,
            target: "_new"
          }
        },
        [
          _c("small", [
            _vm._v(
              _vm._s(_vm.npm_package_version) +
                " last modified: " +
                _vm._s(_vm.last_modified)
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1084c69e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1084c69e","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/sidebar/Sidebar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1084c69e","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/sidebar/Sidebar.vue
// module chunks = 0